// extracted by mini-css-extract-plugin
export var checked = "ChooseMany_checked__tbmdN";
export var chooseManyContainer = "ChooseMany_chooseManyContainer__zPNS7";
export var disabled = "ChooseMany_disabled__C5bGy";
export var explanation = "ChooseMany_explanation__zDXeW";
export var liEnabledOtherChoice = "ChooseMany_liEnabledOtherChoice__KwO+H";
export var liExplanation = "ChooseMany_liExplanation__VUI5Q";
export var md = "768px";
export var otherChoice = "ChooseMany_otherChoice__teyR9";
export var otherChoiceExplanation = "ChooseMany_otherChoiceExplanation__Npkd6";
export var shared = "\"../../../shared.module.css\"";
export var textareaExplanationStyles = "ChooseMany_textareaExplanationStyles__OyBk9";